<template>
    <div class="training-base-info">
        <div class="info-wrap">
            <div class="info-item">
                <span class="info-item-label">培训班名称：</span>
                <span class="info-item-value">{{detail.trainName}}</span>
            </div>
            <div class="info-item">
                <span class="info-item-label">课时：</span>
                <span class="info-item-value">{{detail.period}}</span>
            </div>
            <div class="info-item">
                <span class="info-item-label">学分：</span>
                <span class="info-item-value">{{detail.credit ? detail.credit : '-'}}</span>
            </div>
            <div class="info-item">
                <span class="info-item-label">开始时间：</span>
                <span class="info-item-value">{{detail.startTime}}</span>
            </div>
            <div class="info-item">
                <span class="info-item-label">结束时间：</span>
                <span class="info-item-value">{{detail.endTime}}</span>
            </div>
            <div class="info-item">
                <span class="info-item-label">归属部门：</span>
                <span class="info-item-value">{{detail.trainOrgName}}</span>
            </div>
            <div class="info-item">
                <span class="info-item-label">培训班状态：</span>
                <span class="info-item-value info-item-status">{{statusObj[detail.status]}}</span>
            </div>
        </div>
        <div>
            <el-button size="mini" @click="linkToClass">进入培训班</el-button>
            <el-button size="mini" @click="linkToBack">返回</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: 'TrainingBaseInfo',
    props: ['detail'],
    data() {
        return {
            statusObj: {
                // 0: '已撤销',
                // 1: '未策划',
                // 2: '草案',
                // 3: '策划中',
                // 4: '报名中',
                // 5: '待实施',
                // 6: '实施中',
                // 7: '待结项',
                // 8: '已结项'
                2: '报名未开始',
                3: '报名中',
                4: '培训班未开始',
                5: '开班中',
                6: '待结项',
                7: '已结项'
            }
        }
    },
    methods: {
        linkToClass() {
            this.$router.push({path: '/classroom/detail?id=' + this.$route.query.id})
        },
        linkToBack() {
            this.$router.back()
        }
    }
}
</script>
<style lang="scss" scoped>
@import '../../../styles/variables.scss';

.training-base-info {
    display: flex;
    align-items: flex-start;
    padding: .22rem .3rem .15rem;
    border-bottom: 1px solid $grey_border_color_ccc;
    background: $grey_bg_color_f5;
    .info-wrap {
        display: flex;
        flex-wrap: wrap;
        .info-item {
            width: 3.06rem;
            margin-bottom: .15rem;
            font-size: .14rem;
            line-height: .2rem;
        }
        .info-item-label {
            color: $font_color_A6;
        }
        .info-item-value {
            color: $font_color_08E;
        }
        .info-item-status {
            color: $font_color_51b;
        }
    }
    .el-button {
        display: block;
        &.el-button--mini {
            padding: .09rem .19rem;
        }
    }
    .el-button+.el-button{
        margin-left: 0;
        margin-top: .2rem;
        width: 1.1rem;
    }
}
</style>